import { uiText } from '@/i18n/interface';
import { LayoutDashboard, Award, BookOpen, CreditCard, Play, Users, TrendingUp, Calendar, Settings } from 'lucide-react';

export const adminSections = [
  { value: 'overview', key: 'studio.overview', get fallback() { return uiText("Overview"); }, icon: LayoutDashboard },
  { value: 'students', key: 'studio.students', get fallback() { return uiText("Students"); }, icon: Users },
  { value: 'payments', key: 'tabs.payments', get fallback() { return uiText("Payments"); }, icon: CreditCard },
  { value: 'profiles', key: 'tabs.profiles', get fallback() { return uiText("Profiles"); }, icon: Users },
  { value: 'schedule', key: 'tabs.schedule', get fallback() { return uiText("Schedule"); }, icon: Calendar },
  { value: 'belts', key: 'tabs.beltSystem', get fallback() { return uiText("Belt system"); }, icon: Award },
  { value: 'syllabus', key: 'tabs.syllabus', get fallback() { return uiText("Syllabus"); }, icon: BookOpen },
  { value: 'participation', key: 'tabs.participation', get fallback() { return uiText("Participation"); }, icon: TrendingUp },
  { value: 'training', key: 'tabs.onDemandTraining', get fallback() { return uiText("On-demand training"); }, icon: Play },
  { value: 'settings', key: 'tabs.settings', get fallback() { return uiText("Settings"); }, icon: Settings },
];
